import React from 'react';

// Inline "in progress" pill shared by the product / brand card intel rows:
// the same spinner the Brand Intelligence status badge (PrepPackStatusBadge)
// shows while a pack generates, so PDP and Consumer Voice runs read the
// same way on a card as a BI run does.
export function RunningBadge({ label = 'Running', title }: { label?: string; title?: string }) {
  return (
    <span
      className="inline-flex items-center gap-[6px] text-[11px] font-semibold text-accent-text shrink-0"
      title={title}
      role="status"
    >
      <span className="w-3 h-3 border-2 border-tint border-t-accent rounded-full animate-ppSpin" />
      {label}
    </span>
  );
}
